var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWexplore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 14.9C17.7 14.2 18 13.4 18 12.5C18 10 16 8 13.5 8C11 8 9 10 9 12.5C9 15 11 17 13.5 17C14.4 17 15.2 16.7 15.9 16.3L19.1 19.5L20.5 18.1L17.3 14.9ZM13.5 15C12.1 15 11 13.9 11 12.5C11 11.1 12.1 10 13.5 10C14.9 10 16 11.1 16 12.5C16 13.9 14.9 15 13.5 15ZM10 18V20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0C14.84 0 18.87 3.44 19.8 8H17.73C17.4181 6.79184 16.8279 5.67338 16.0066 4.73401C15.1853 3.79465 14.1557 3.06042 13 2.59V3C13 4.1 12.1 5 11 5H9V7C9 7.55 8.55 8 8 8H6V10H8V13H7L2.21 8.21C2.08 8.79 2 9.38 2 10C2 14.41 5.59 18 10 18Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWexplore);
export default __webpack_public_path__ + "static/media/wexplore.07600ec2ea603f7a3a22df21da8be3ed.svg";
export { ForwardRef as ReactComponent };